// extracted by mini-css-extract-plugin
export default {"card":"J1-z","carouselContainer":"K1-z","carouselContent":"L1-z"};